<template>
  <v-card flat>
    <v-card-text>
      <p>
        La présente politique de gestion des données personnelles est conçue
        pour vous informer sur la façon dont les données personnelles sont
        utilisées et, également, vous rappeler quels sont vos droits et comment
        vous pouvez les exercer.
      </p>

      <h3>Qui est responsable de mes données personnelles ?</h3>
      <br />

      <p>
        AGIL est un système informatique de l’interprofession laitière, conçu
        conjointement par le Centre National Interprofessionnel de l'Économie
        Laitière (CNIEL), Maison du Lait Services et les entités de la filière
        laitière présentes à la Maison du Lait, à savoir :
      </p>
      <p></p>

      <p>
        Fédération Nationale des Producteurs de Lait (FNPL), Fédération
        Nationale des Industries Laitières (FNIL), la Coopération Laitière,
        Association Nationale Interprofessionnelle CAPrine (ANICAP), Association
        de la Transformation LAitière française (ATLA), Fédération Nationale des
        Eleveurs de Chèvres (FNEC), l’Institut d'Etudes Supérieures d'Industrie
        et d'Economie Laitières (IESIEL), Institut Professionnel du Lait de
        Consommation (IPLC), GIE Maison du Lait Gestion, SOGAL SOCAMUEL,
        Syndifrais et Syndilait
      </p>

      <p>
        AGIL est l’Annuaire mutualisé de l'interprofession laitière, contenant
        les contacts professionnels des collaborateurs des entités de la filière
        laitière présents à la Maison du Lait précités mais également des
        contacts professionnels de la filière laitière à l’extérieur, ainsi que
        les contacts d’organismes publics.
      </p>
      <p></p>

      <p>
        Le CNIEL est l’administrateur central d’AGIL et le point de contact
        unique pour toute demande des utilisateurs :
      </p>
      <p></p>

      <p style="margin-left:26px;">
        CNIEL - Association loi 1901 déclarée à la Préfecture de Paris le 8
        avril 1974, enregistrée sous le n°W751035614, dont le siège social est à
        la Maison du Lait, 42 rue de Châteaudun, 75314 Paris cedex 09. Tel. :
        <a href="tel:+33149707111">+ 33 1 49 70 71 11</a> –
        <a href="https://www.filiere-laitiere.fr/">www.filiere-laitiere.fr</a>.
      </p>

      <p>
        Les utilisateurs d’AGIL sont les collaborateurs des entités de la
        filière laitière présents à la Maison du Lait.
      </p>

      <h3>Quelles données personnelles sont enregistrées ?</h3>
      <br />

      <h4>Données personnelles fournies par la Personne concernée</h4>
      <br />

      <p>
        Toute personne souhaitant accéder à un outil utilisant AGIL comme
        gestion de compte d'accès ( ex. SINAPS et Cniel-Infos), gérées par le
        CNIEL, doivent créer un compte AGIL en ligne. La demande de création
        d’un compte AGIL par la Personne concernée s’effectue au moyen du
        formulaire d’inscription en ligne prévu à cet effet. Les données
        personnelles qui sont collectées dans ce formulaire sont enregistrées
        par le système. Toutes les données affichées sont obligatoires.
      </p>
      <p></p>

      <p>Les informations suivantes doivent être renseignées :</p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>Civilité</li>
        <li>Nom, Prénom</li>
        <li>Adresse email</li>
        <li>Numéro de téléphone.</li>
        <li>Nom usuel de l’entité</li>
        <li>Fonction</li>
        <li>Adresse professionnelle</li>
      </ul>
      <br />

      <p>
        Le demandeur a la possibilité de laisser un commentaire avec toute
        information utile pouvant permettre la validation de sa demande de
        création de compte.
      </p>
      <p>
        Le demandeur consent par une case à cocher au traitement de ses données
        tel que défini au présent document.
      </p>
      <p>
        Le demandeur est informé de la prolongation de la conservation de ses
        données, après vérification de celles-ci, par email.
      </p>

      <h4>Données personnelles transmises par l’employeur</h4>
      <br />

      <p>
        Les entités de la filière laitière, employeurs des collaborateurs de la
        MDL, transmettent aux gestionnaires AGIL les données personnelles de
        leurs collaborateurs listées ci-dessous :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>Civilité</li>
        <li>Nom, Prénom</li>
        <li>Adresse email</li>
        <li>Numéro de téléphone.</li>
        <li>Nom usuel de l’entité</li>
        <li>Fonction</li>
        <li>Service – Pôle</li>
      </ul>
      <br />

      <p>
        Les collaborateurs sont informés de toute demande de création de compte
        les concernant et de la prolongation de la conservation de leurs
        données, après vérification de celles-ci, par email.
      </p>
      <p></p>

      <h4>Données personnelles transmises par les utilisateurs</h4>
      <br />

      <p>
        A la demande d’un utilisateur, le gestionnaire concerné peut créer une
        fiche contact pour tout contact professionnel lié à la filière laitière.
        L’utilisateur transmet les informations suivantes sur le contact à créer
        :
      </p>
      <p></p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>Civilité</li>
        <li>Nom, Prénom</li>
        <li>Adresse email</li>
        <li>Numéro de téléphone.</li>
        <li>Nom usuel de l’entité</li>
        <li>Fonction</li>
      </ul>

      <p>
        Les gestionnaires ont ensuite la possibilité de créer des instances pour
        les utilisateurs concernés.
      </p>
      <p></p>

      <p>
        Les Personnes concernées sont informées de toute création de compte les
        concernant et de la prolongation de la conservation de leurs données,
        après vérification de celles-ci, par email.
      </p>

      <h4>Données personnelles collectées automatiquement</h4>
      <br />

      <p>
        Lorsque l’utilisateur se connecte à son compte personnel pour accéder à
        ses données sur AGIL au moyen d’un ordinateur fixe ou portable, d’un
        mobile multifonction ou d’une tablette, des informations techniques de
        connexion et de navigation sont enregistrées par le système.
      </p>

      <p>
        Des cookies sont également déposés sur l’équipement terminal de
        l’utilisateur lorsqu’il se connecte à AGIL. Pour connaître les
        différents cookies utilisés et les moyens de les paramétrer, voir
        ci-dessous [lien vers la rubrique « cookies » à la fin de ce document].
      </p>

      <h3>
        Pour quelles utilisations les données personnelles sont-elles
        enregistrées ?
      </h3>
      <br />

      <h4>Finalité principale</h4>
      <br />

      <p>
        L’objectif principal du traitement des données personnelles est de
        pouvoir mettre à disposition des collaborateurs de la filière laitière
        présents à la MDL un annuaire des contacts professionnels en lien avec
        la filière laitière afin de faciliter les échanges et la diffusion
        d’information relatives à l'activité de l'interprofession et aux
        produits laitiers, aux acteurs de la filière.
      </p>

      <p>
        Ce traitement de données est mis en œuvre en application des bases
        légales suivantes :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Article 6-c du règlement général sur la protection des données (RGPD)
        </li>
        <li>
          Intérêt légitime des Responsables conjoints de traitement à détenir
          l’annuaire des contacts professionnels pour le bon fonctionnement de
          la filière laitière et la diffusion d'informations relatives à
          l'activité de l'interprofession et aux produits laitiers aux acteurs
          de la filière
        </li>
        <li>
          Consentement des personnes faisant la demande d'accéder à un outil
          utilisant AGIL comme gestion de compte d'accès (SINAPS – Cniel-infos-
          Office 365)
        </li>
      </ul>
      <br />

      <p>
        Les données personnelles sont utilisées pour fournir les services
        suivants :
      </p>
      <p></p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Recenser les coordonnées professionnelles de plusieurs catégories de
          personnes (qui sont parfois aussi des coordonnées personnelles pour
          les producteurs par exemple) ainsi que les personnes morales :
        </li>
        <ul>
          <li>Des adhérents des membres du CNIEL</li>
          <li>
            Des salariés de toutes les entités de la filière laitière présentes
            à la Maison du Lait
          </li>
          <li>
            Des organismes publics (écoles, INRA, ministères…) avec lesquels les
            collaborateurs de la filière laitière de la Maison du Lait
            travaillent
          </li>
          <li>
            De tous les prestataires/partenaires avec lesquels les
            collaborateurs des entités de la filière laitière hébergées à la
            Maison du Lait travaillent.
          </li>
        </ul>
        <li>Regrouper les contacts via :</li>
        <ul>
          <li>Des « instances »</li>
        </ul>
        <li>
          Synchroniser les contacts avec la messagerie Outlook et permettre des
          envois massifs à destination d’instances.
        </li>
        <li>
          Rechercher des contacts en lançant une recherche à tout l’annuaire.
        </li>
        <li>
          Alimenter les logiciels de facturation qui interrogent AGIL pour
          identifier la structure dont est issue un contact.
        </li>
        <li>
          Exporter les listes de contacts sur Excel, notamment pour des
          diffusions via sms et mails, mais également pour générer des
          étiquettes ou courriers type
        </li>
        <li>
          Synchroniser les contacts et gérer les autorisations d’accès avec des
          annuaires d’applications tierces pour permettre l’utilisation d’outils
          CNIEL / Maison du Lait (SINAPS, CNIEL-Infos, Office 365), qui
          impliquent la création de fiches dans AGIL pour créer un compte
          d’accès à ces outils.
        </li>
      </ul>
      <br />

      <h4>Finalités complémentaires</h4>
      <br />

      <p>
        Les données personnelles des Personnes concernées sont également
        utilisées sur la base des textes suivants :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Article 6-f du règlement général sur la protection des données (RGPD)
        </li>
        <li>
          Prévention, détection et lutte contre la fraude informatique pour la
          sécurité et la confidentialité des données d’AGIL
        </li>
        <li>
          A des fins de preuve dans le cadre d’obligations légales et
          réglementaires
        </li>
        <li>
          Pour instruire les demandes liées à l’exercice des droits des
          Personnes concernées concernant leurs données personnelles.
        </li>
      </ul>
      <br />

      <h3>Qui peut accéder aux données personnelles ?</h3>
      <br />

      <h4>Les destinataires habilités à accéder aux données</h4>
      <br />

      <p>
        Les données personnelles enregistrées dans AGIL® sont accessibles aux
        organismes habilités suivants :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Le service informatique interne du CNIEL et de MDLS pour
          l’administration centrale du système
        </li>
        <li>
          Les collaborateurs des entités appartenant à la filière laitière au
          sein de la MDL
        </li>
      </ul>
      <br />

      <p>
        Les données personnelles sont également susceptibles d’être transmises
        sur réquisitions des autorités administratives et judiciaires
        autorisées.
      </p>

      <h4>Les sous-traitants techniques</h4>
      <br />

      <p>
        Les données personnelles des utilisateurs et des contacts professionnels
        sont accessibles par des prestataires spécialisés, agissant en qualité
        de sous-traitants, et spécifiquement mandatés par le CNIEL pour fournir
        des services techniques qui sont nécessaires au fonctionnement et à la
        sécurité d’AGIL.
      </p>

      <p>
        Les sous-traitants ultérieurs agissent uniquement sur instructions
        écrites et sont tenus à la confidentialité, ainsi qu’au strict respect
        des dispositions Informatique et Libertés en vigueur. Ils ne peuvent
        réutiliser les données personnelles auxquelles ils accèdent, ni céder ou
        transférer les données, à titre gratuit ou payant.
      </p>

      <p>
        Les moyens de traitement des sous-traitants techniques (développeur,
        mainteneur, hébergeur) sont localisés en France, ou dans l’Espace
        Economique Européen, et ils ne sont pas autorisés à transférer les
        données vers un pays tiers n’ayant pas un niveau de protection adéquat
        au sens de la réglementation Informatique et Libertés.
      </p>

      <p>
        Par dérogation à ce qui précède, et pour certaines technologies
        complémentaires nécessitant le recours à des sous-traitants dont les
        moyens de traitement sont localisés dans un pays tiers ne présentant pas
        un niveau de protection adéquat. Dans ce cas, le sous-traitant est
        soumis au respect des mêmes obligations que celles fixées aux présentes,
        soit au moyen de clauses contractuelles types, soit selon les modalités
        prévues par décision de la Commission Européenne ou tout autre
        dispositif équivalent reconnu par les autorités de contrôle (BCR) ou
        garantie appropriée telle que définie à l’article 46 du RGPD.
      </p>

      <h3>Quelle est la durée de conservation des données personnelles ?</h3>
      <br />

      <p>
        La durée de conservation des données personnelles varie selon le profil
        de la Personne concernée. Dans tous les cas les fiches contacts font
        l’objet d’une mise à jour tous les 2 ans :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Collaborateurs de la Maison du Lait : pour toute la durée d’emploi du
          collaborateur puis suppression dans les 3 mois après son départ.
          Demande de validation de mise à jour tous les 2 ans par email à
          l’employeur du collaborateur concerné. Lorsque les données du
          collaborateur sont prolongées, celui-ci reçoit un email d’information
          de la prolongation de sa fiche contact dans AGIL et des données
          contenues dans cette fiche.
        </li>
        <li>
          Personnes extérieures et dont le traitement de données repose sur
          l’intérêt légitime de la filière laitière : pour toute la durée de la
          relation professionnelle avec la personne concernée ou jusqu’à la
          demande de suppression par la personne concernée ou un utilisateur.
          Demande de validation de mise à jour tous les 2 ans par email à
          l’utilisateur concerné. Sans réponse au bout d'un mois le contact est
          supprimé par les gestionnaires AGIL (30 jours en corbeille puis
          suppression complète). Lorsque les données de la personne extérieure
          sont prolongées, celle-ci reçoit un email d’information de la
          prolongation de sa fiche contact dans AGIL et des données contenues
          dans cette fiche.
        </li>
        <li>
          Personnes extérieures dont le traitement de données repose sur le
          consentement : pour toute la durée de la relation professionnelle avec
          la personne/ou jusqu’au retrait de son consentement. Demande de
          validation de mise à jour tous les 2 ans par email à l’utilisateur
          concerné par ce contact. Sans réponse de l’utilisateur au bout d'un
          mois le contact est supprimé par les gestionnaires AGIL (30 jours en
          corbeille puis suppression complète du contact de toutes les instances
          et groupes ou liste de diffusion). Lorsque les données de la personne
          extérieure sont prolongées, celle-ci reçoit un email d’information de
          la prolongation de sa fiche contact dans AGIL et des données contenues
          dans cette fiche.
        </li>
      </ul>
      <br />

      <h3>
        Quelles sont les mesures de sécurité et de protection des données
        personnelles ?
      </h3>
      <br />

      <p>
        AGIL est un système d’information sécurisé, en accès restreint,
        intégrant des mesures techniques et organisationnelles de protection des
        données conformes à la réglementation en vigueur, à l’état de l’art et
        aux bonnes pratiques du secteur (CNIL, ANSSI).
      </p>

      <p>
        Les utilisateurs accèdent à AGIL au moyen de codes d’accès strictement
        personnels et confidentiels, composés d’un identifiant unique et d’un
        mot de passe respectant l’état de l’art en matière d’authentification et
        de sécurité (robustesse, changement, renouvellement).
      </p>

      <p>
        Les responsables conjoints de traitement et les sous-traitants
        ultérieurs s’engagent notamment à respecter les mesures suivantes :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Prévenir toute destruction accidentelle ou illicite, perte,
          altération, utilisation détournée, diffusion ou accès non autorisés,
          ainsi que toute autre forme de traitement illicite
        </li>
        <li>
          Ne pas divulguer, sous quelque forme que ce soit, à des tiers
          non-autorisés tout ou partie des données personnelles
        </li>
        <li>
          Ne pas traiter de données personnelles autres que celles concernées
          par les présentes, même si l’accès à ces données est techniquement
          possible
        </li>
        <li>
          Veiller à ce que les personnes autorisées à traiter les données
          personnelles soient soumises à des obligations appropriées de
          confidentialité.
        </li>
      </ul>
      <br />

      <h3>
        Quels sont les droits des utilisateurs et personnes concernées sur leurs
        données personnelles ?
      </h3>
      <br />

      <p>
        Tout utilisateur ou personne concernée extérieure à la MDL dont les
        données personnelles sont traitées par AGIL peut, à tout moment, accéder
        et obtenir copie de ses données, les faire rectifier ou effacer,
        s’opposer à leur traitement, en demander la limitation ou la
        portabilité.
      </p>

      <p>
        Toutefois, l’utilisateur en tant que collaborateur interne à la MDL est
        informé de l’existence de dérogations pour l’exercice de certains de ces
        droits, notamment de limitation ou de suppression, qui peuvent
        restreindre ou empêcher l’utilisation d’AGIL et de tout le système
        d’information de la MDL.
      </p>

      <p>
        Pour toute demande d’exercice de ces droits, le délégué à la protection
        des données du CNIEL est l’interlocuteur des utilisateurs, selon les
        modalités suivantes :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          Par courrier électronique à l’adresse suivante :
          <a href="mailto:donneespersonnelles@cniel.com"
            ><span>donneespersonnelles@cniel.com</span></a
          >
        </li>
        <li>
          Par courrier postal : CNIEL – Service juridique - 42 rue de Châteaudun
          – 75009 Paris.
        </li>
      </ul>
      <br />

      <h3>Cookies</h3>
      <br />

      <h4>Qu’est-ce qu’un cookie ?</h4>
      <br />

      <p>
        Le terme cookie couvre l’ensemble des traceurs (pixels, balises, tags,
        etc.) qui sont déposés sous forme d’un fichier texte sur l’équipement de
        l’internaute lors de la consultation d’un site internet, des réseaux
        sociaux ou d’une application mobile. Ce fichier contient plusieurs
        données, tel que le nom du serveur qui l'a déposé, un identifiant unique
        ou encore la durée d’enregistrement du cookie.
      </p>

      <h4>Quels sont les cookies utilisés ?</h4>
      <br />

      <p>
        Les cookies qui peuvent être utilisés sont de plusieurs catégories en
        fonction de leur(s) finalité(s) :
      </p>

      <ul style="list-style-type: disc;margin-left:26px;">
        <li>
          des cookies techniques pour détecter d’éventuels problèmes lors de la
          navigation, ainsi que des cookies qui sont nécessaires au bon
          fonctionnement du site :
        </li>
        <br />
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          class="elevation-1"
        ></v-data-table>
        <br />
        <li>
          des cookies « Analytics » (ou de performance) pour suivre la
          fréquentation du site et avoir des statistiques d’audiences (ex :
          nombre de visites, pages consultées, temps passé sur le site, région
          de connexion...). Ces données servent uniquement à suivre et améliorer
          les services du site et ne sont pas partagées avec des tiers.
        </li>
        <br />
        <v-data-table
          :headers="headers"
          :items="itemsApplicatif"
          :no-data-text="'Aucun cookie de ce type'"
          hide-default-footer
          class="elevation-1"
        ></v-data-table>
      </ul>
      <br />

      <h4>Quels sont les droits des utilisateurs sur les cookies ?</h4>
      <br />

      <p>
        Lors de la première visite sur le site AGIL un bandeau informe
        l’utilisateur de la présence de cookies et lui demande son consentement
        quant à l’activation de ses cookies, sauf pour certains cookies
        techniques qui sont nécessaires au fonctionnement du site et ne peuvent
        être supprimés.
      </p>

      <p>
        L’utilisateur peut à tout moment paramétrer l’enregistrement des
        informations relatives à sa navigation en cliquant sur « Gestion des
        cookies » en bas de page du site.
      </p>

      <p>
        La gestion des cookies peut également se faire de la manière décrite par
        la CNIL à l’adresse suivante :
        <a href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser"
          >https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser</a
        >.
      </p>

      <p>
        Le site Infolabo® peut également donner accès, par des liens
        hypertextes, à d’autres sites web publiés par des tiers qui sont
        susceptibles d’utiliser leur propre politique de gestion des cookies
        pour tracer la navigation de leurs visiteurs.
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: 'Nom du cookie',
          value: 'cookie',
        },
        {
          text: 'Partenaire',
          value: 'partenaire',
        },
        {
          text: 'Thématique',
          value: 'thematique',
        },
        {
          text: 'Finalité de traitement et commentaire',
          value: 'finalite',
        },
        {
          text: 'Durée de vie',
          value: 'duree',
        },
      ],
      items: [
        {
          cookie: 'sessionStorage',
          partenaire: '-',
          thematique: 'Connexion',
          finalite:
            'Token d\'authentification et informations basiques de l\'utilisateur',
          duree: 'Tant que l\'onglet est ouvert',
        },
        {
          cookie: 'localStorage',
          partenaire: '-',
          thematique: 'Gestion d\'état applicatif',
          finalite:
            'Permet l\'utilisation de l\'application avec plusieurs onglets',
          duree: 'Indéterminée',
        },
      ],
      itemsApplicatif: [],
    };
  },
};
</script>
